import { FlexRow } from '../Flex'
import { BoxProps } from '@mui/material/Box'

const WelcomeText: React.FC<React.PropsWithChildren<BoxProps>> = (props) => {
  return <FlexRow {...props}>Get Paid to Explore the World!</FlexRow>
}

export default WelcomeText
